export default __webpack_public_path__ + "static/media/title-about-us.53282776.png";